import * as ai from './aiApi'
import * as aiConfig from './aiConfigApi'
import * as historyText from './historyTextApi'

export default {
    ai,
    historyText,
    aiConfig,
}